import {createSelector} from 'reselect'
import {selectTaskManagement} from '../selectors'

export const getCpPanelState = createSelector(
    selectTaskManagement,
    (tmState) => tmState.cpPanel
)

export const getCPPanelMaxWidth = createSelector(
    getCpPanelState,
    (cpPanelState) => cpPanelState.resizableMaxWidth
)

export const getCPPanelMinWidth = createSelector(
    getCpPanelState,
    (cpPanelState) => cpPanelState.resizableMinWidth
)

export const getCPPanelWidth = createSelector(
    getCpPanelState,
    (cpPanelState) => cpPanelState.width
)

export const getCollapsedCustomersSet = createSelector(
    getCpPanelState,
    (cpPanelState) => cpPanelState.collapsedCustomersSet
)


// WEBPACK FOOTER //
// ./web/js/taskManagement/customersProjectsPanel/selectors.js